






































import TaskSourceSystems from './TaskSourceSystems.vue';
import ErrorMessagesComponent from "@/shared/components/ErrorMessages.vue";
import MessageComponent from '@/shared/components/Message.vue';
import LoaderComponent from '@/shared/components/Loader.vue';

import HttpService from "@/shared/services/http-service";
import TaskService from "../services/task-service";

import {formatDate} from '@/shared/services/format-date-filter';
import {useActions, useGetters} from "vuex-composition-helpers";
import {defineComponent, onMounted, ref} from "@vue/composition-api";

export default defineComponent({
  name: "TasksWidget",
  components: {
    TaskSourceSystems,
    ErrorMessagesComponent,
    MessageComponent,
    LoaderComponent
  },
  props: {
    configRaw: {
      type: Object,
      required: true
    }
  },
  setup: (props) => {
    const {
      config,
      tasks,
      errors,
      loading,
      noResultsFound
    } = useGetters(['config', 'tasks', 'errors', 'loading', 'noResultsFound'])
    const {
      setConfig,
      setLoading,
      setError,
      setErrors,
      setTaskSourceSystems
    } = useActions(["setConfig", "setLoading", "setError", "setErrors", "setTaskSourceSystems"])

    const lastRefreshDate = ref('');

    function setLastRefreshDate(): void {
      lastRefreshDate.value = formatDate(new Date().toISOString(), 'LLL', config.value.language);
    }

    function reloadTasks() {
      setLoading(true);
      setErrors([]);
      loadData();
      setLastRefreshDate();
    }

    function loadData() {
      TaskService.getOpenTasks(config.value, HttpService)
          .then((taskSourceSystems) => {
            setTaskSourceSystems(taskSourceSystems);
          })
          .catch((error) => {
            console.error(error);
            setError(getErrorText())
          })
          .finally(() => setLoading(false));
    }

    onMounted(() => {
      try {
        setConfig(props.configRaw);
        setErrors([]);
        loadData();
        setLastRefreshDate();
      } catch (error) {
        setLoading(false);
        setError(getErrorText())
      }
    })

    function getErrorText(): string {
      return config.value.language.toLowerCase() === "nl"
          ? "Er gaat iets fout, probeer het later nog een keer"
          : "Something went wrong, please try again later";
    }

    return {config, tasks, errors, loading, noResultsFound, reloadTasks, lastRefreshDate}
  }
})
